<template>
  <!--    href="#results-cards"-->
  <a href="javascript:void(0);" @click.prevent="showFilter" class="filters-mobile-results-btn" type="submit">
    Leita í söluskrá
    <span>{{ resultCount }}</span>
    <leita class="leita" />
  </a>
</template>

<script>
//import scroll from "../../helpers/scroll";

import {mapGetters, mapMutations} from "vuex";
import Leita from "@/components/svg/nav/Leita";

export default {
  components:{
    Leita
  },
  methods: {
    ...mapMutations(['setShowMenu']),
    showFilter() {
      if (this.showMenu) this.$scrollTo(".header-block", 1000);

      /*this.$store.state.filter.showAll = true;
      console.log(this.$store.state.filter);
      if(this.showMenu){
        this.$router.push("/nyir-bilar?showAll=true")
      }*/
      this.setShowMenu(!this.showMenu);
    }
  },
  computed: {
    ...mapGetters(['showMenu']),
    selectedFilterCount() {
      return this.$store.state.selected_filters_count;
    },
    resultCount() {
      return this.$store.state.resultCount;
    }
  }
}
</script>
